<script>
import { mapGetters } from 'vuex';
import XmlChannelStatusCardHeader from './XmlChannelStatusCardHeader';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'XmlChannelStatusPhCard',
  components: {
    XmlChannelStatusCardHeader,
  },
  mixins: [
    dateMixin,
  ],
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      badges: 'xmlChannelStatus/getBadges',
    }),
  },
  methods: {
    openJobList(xmlChannel) {
      this.$emit('open-job-list', xmlChannel);
    },
  },
};
</script>

<template>
  <v-flex v-if="xmlChannel.latestJob">
    <xml-channel-status-card-header :xml-channel="xmlChannel">
      <template v-slot:tooltip>
        <v-tooltip
          v-if="xmlChannel.latestJob.nonSuccessfulJobOverview"
          class="mr-2"
          min-width="130"
          top
        >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="info">info</v-icon>
          </template>
          <v-flex>
            <v-container grid-list-xs pa-2>
              <v-layout
                v-for="(type, key) in xmlChannel.latestJob.nonSuccessfulJobOverview"
                :key="key"
                row
              >
                <v-flex xs10 grow>
                  {{ $t(`badges.${badges[key].label}`) }}:
                </v-flex>
                <v-flex xs2>
                  {{ type }}
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-tooltip>
      </template>
    </xml-channel-status-card-header>
    <v-card-text class="pt-0 pb-1 mt-2">
      <span>
        <strong>{{ $t('xmlChannelStatus.xmlChannelStatusCard.receivedUpdates') }}:</strong>
      </span>
      <span>
        {{ xmlChannel.latestJob.updates }}
      </span>
    </v-card-text>
    <v-card-text class="py-0">
      <b>Import:</b>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span v-if="xmlChannel.latestJob.started">
        {{ formatDate(xmlChannel.latestJob.started) }}
      </span>
      <span v-else class="pl-2">-</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span v-if="xmlChannel.latestJob.started">
        {{ formatDate(xmlChannel.latestJob.started) }}
      </span>
      <span v-else class="pl-2">-</span>
    </v-card-text>
    <v-card-text class="py-0">
      <b>Synchronization:</b>
      <span class="grey--text caption">(Not Applicable)</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Started:
      </span>
      <span class="pl-2">-</span>
    </v-card-text>
    <v-card-text class="pt-0 pb-1 pl-4">
      <span>
        Finished:
      </span>
      <span class="pl-2">-</span>
    </v-card-text>
    <v-divider class="mx-2 pt-1"></v-divider>
    <v-btn @click="openJobList(xmlChannel)" color="primary" small disabled outline>
      {{ $t('xmlChannelStatus.xmlChannelStatusCard.productList') }}
    </v-btn>
  </v-flex>
  <v-flex v-else>
    <v-card-title dark>
      {{ xmlChannel.webservice }}
      <v-spacer/>
      <small>{{ xmlChannel.system }}</small>
      <v-spacer/>
      <badge :badge="badges['NO_CONTENT']"/>
    </v-card-title>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusPHCard.vue